import React from 'react';

const TickGreen = ({ width = 9, height = 7, className, ...rest }) => {
  return (
    <svg
      role="img"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.51354 3.02619C1.27697 2.7423 0.855044 2.70394 0.571153 2.94052C0.287262 3.17709 0.248905 3.59901 0.485481 3.8829L1.51354 3.02619ZM2.94696 5.79148L3.46099 5.36312L2.94696 5.79148ZM3.14841 5.79624L3.64166 6.24838L3.64166 6.24838L3.14841 5.79624ZM8.03821 1.45214C8.28792 1.17973 8.26952 0.756467 7.99711 0.506757C7.7247 0.257048 7.30143 0.27545 7.05172 0.547861L8.03821 1.45214ZM0.485481 3.8829L2.43293 6.21984L3.46099 5.36312L1.51354 3.02619L0.485481 3.8829ZM3.64166 6.24838L8.03821 1.45214L7.05172 0.547861L2.65517 5.3441L3.64166 6.24838ZM2.43293 6.21984C2.74413 6.59328 3.31318 6.60672 3.64166 6.24838L2.65517 5.3441C2.87416 5.10521 3.25352 5.11416 3.46099 5.36312L2.43293 6.21984Z"
        fill="#2AB14F"
      />
    </svg>
  );
};

export default TickGreen;
